export default __webpack_public_path__ + "static/media/hero.7d0825ff.png";